
export default {
  props: ["shipping"],
};
